import { get } from 'lodash'
import querystring from 'query-string'
import { noIndex, setErrorPage, setSeoMeta } from '../actions/common'
import { logError, LandingPageUnpublishedError } from '../utils/errors'
import getProxyApiUrl from '../utils/getProxyApiUrl'
import axiosVerbose from '../utils/axios/axiosVerbose'
import activeFeatures from '../utils/activeFeatures'

const fetchLandingPageContent = (parsedUrl, opts) => {
  return (dispatch, getState) => {
    const apiUrlPrefix = getProxyApiUrl(opts)
    const site = get(getState(), 'common.currentSite') || 'themeforest'
    const queryString = querystring.stringify({
      site,
      path: parsedUrl.pathname
    })

    return axiosVerbose
      .get(`${apiUrlPrefix}/shopfront_api/landing_page?${queryString}`)
      .then(res => {
        const { title, meta_description, html, css, published } = res.data

        if (activeFeatures(parsedUrl.query).includes('sneakpeek')) {
          dispatch(noIndex())
        } else if (!published) {
          throw new LandingPageUnpublishedError()
        }

        dispatch(setSeoMeta({ title, meta_description }))

        return dispatch(fetchLandingPageContentSuccess({ html, css }))
      })
      .catch(err => {
        if (err.statusCode !== 404) {
          logError(err)
        }

        dispatch(noIndex())
        dispatch(setErrorPage('NotFoundContainer'))

        return dispatch(fetchLandingPageContentFailure(err))
      })
  }
}

const fetchLandingPageContentSuccess = content => {
  return {
    type: 'fetchLandingPageContentSuccess',
    payload: content
  }
}

const fetchLandingPageContentFailure = error => {
  return {
    type: 'fetchLandingPageContentFailure',
    error: true,
    httpStatus: error.statusCode || 404
  }
}

export default fetchLandingPageContent



// WEBPACK FOOTER //
// ./common/actions/fetchLandingPageContent.js